import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'creditCardNumber' })
export class CreditCardNumberPipe implements PipeTransform {
  constructor() { }

  transform(value: any) {
    if (typeof value === 'string') {
      let cardNumber = value.replace(' ', '').replace('-', '');
      if (cardNumber.length === 16) {
        return '**** **** **** ' + value.substr(12);
      }
    }

    return value;
  }
}
